import { createAction } from "redux-actions";
import {
  CLEAR_SCORE_CARDS_BY_TYPE,
  GET_SCORE_CARDS_BY_TYPE,
} from "../types/getScoreCardsByTypeTypes";
import createAsyncActions from "../utilities/createAsyncActions";

export const {
  getScoreCardsByType,
  getScoreCardsByTypePending,
  getScoreCardsByTypeFulfilled,
  getScoreCardsByTypeRejected,
} = createAsyncActions(GET_SCORE_CARDS_BY_TYPE, "getScoreCardsByType");

export const clearScoreCardsByType = createAction(CLEAR_SCORE_CARDS_BY_TYPE);



// WEBPACK FOOTER //
// ./src/actions/getScoreCardsByTypeActions.js